import { EncounterFinancials, TealCompEncounter, TealCompEncounterHeader } from "../../models/encounter";
import { Diary, ReceivedEmail, SentEmail, Note, NoteAddendum, User, HarloweSupport, Appointment } from "@harlowe/core";
import { Bill, Invoice } from "../../models/finance";
import { EncounterFilter } from "../../services/encounter.service";
import { MedicalBill } from "../../models/medical-bill";

export namespace Encounters 
{

    export class UserLoggedIn
    {
        static readonly type = "[Encounter Login Action] Successful Login";
        constructor(public payload: { user: User }) {}
    }

    export class EncounterFilterSet
    {
        static readonly type = "[Anywhere] Encounter Filter Set";
        constructor(public payload: {filter: EncounterFilter}) {}
    }

    export class NewEncounterReceived
    {
        static readonly type = "[Encounter Service] New Encounter Received";
        constructor(public payload: { encounter: TealCompEncounterHeader }) {}
    }

    export class EncounterUpdated
    {
        static readonly type = "[Encounter Service] Encounter Updated";
        constructor(public payload: {header: TealCompEncounterHeader,encounter: TealCompEncounter}) {}
    }

    export class EncounterAssigned
    {
        static readonly type = "[Encounter Service] Ecnounter Assigned";
        constructor(public payload: {encounter: TealCompEncounterHeader}) {}
    }

    export class EncounterUnassigned
    {
        static readonly type = "[Encounter Service] Encounter Unassigned";
        constructor(public payload: {encounter: TealCompEncounterHeader}) {}
    }

    export class EncounterOpenedFromEncounterManager
    {
        static readonly type = "[Encounter Manager] Encounter Opened";
        constructor(public payload: {header: TealCompEncounterHeader}){}
    }

    export class EncounterOpenedFromDiary
    {
        static readonly type = "[Diary Manager] Encounter Opened";
        constructor(public payload: {encounterId: number}){}
    }

    export class EncounterOpenedFromEmailSidebar
    {
        static readonly type = "[Encounter Sidebar] Encounter Opened";
        constructor(public payload: {encounterId: number}) {}
    }

    export class EncounterOpenedFromReferralManager
    {
        static readonly type="[Referral Manager] Encounter Opened";
        constructor(public payload: {encounterId: number}){}
    }

    export class EncounterOpenedFromClaimCard
    {
        static readonly type = "[Claim Card] Encounter Opened";
        constructor(public payload: {header: TealCompEncounterHeader}){}
    }

    export class WorkbenchEncounterClosed
    {
        static readonly type = "[Workbench] Encounter Closed";
        constructor(public payload: {encounter: TealCompEncounter}){}
    }

    export class EncounterSelected
    {
        static readonly type="[Workbench] Encounter Selected";
        constructor(public payload: {index: number}){}
    }

    export class EncounterLocked
    {
        static readonly type="[Encounter Service] Encounter Locked";
        constructor(public payload: {encounter: TealCompEncounter}){}
    }

    export class EncounterServiceEncounterClosed
    {
        static readonly type="[Encounter Service] Encounter Closed";
        constructor(public payload: {encounter: TealCompEncounterHeader}){}
    }

    export class EncounterUnlocked
    {
        static readonly type="[Encounter Service] Encounter Unlocked";
        constructor(public payload: {encounter: TealCompEncounter}){}
    }

    export class PersistState
    {
        static readonly type="[Encounter State] Persist";
    }

    export class DiaryUpdated
    {
        static readonly type="[Encounter Service] Diary Updated";
        constructor(public payload: {encounterId: number, diary: Diary}){}
    }

    export class DiaryAdded
    {
        static readonly type="[Encounter Service] Diary Added";
        constructor(public payload: {encounterId: number, diary: Diary}){}
    }

    export class NoteUpdated
    {
        static readonly type="[Encounter Service] Note Updated";
        constructor(public payload: {encounterId: number, note: Note}){}
    }

    export class NoteDeleted
    {
        static readonly type="[Encounter Service] Note Deleted";
        constructor(public payload: {encounterId: number, noteId: number}){}
    }

    export class NoteAdded
    {
        static readonly type="[Encounter Service] Note Added";
        constructor(public payload: {encounterId: number, note: Note}){}
    }

    export class NoteAddendumAdded
    {
        static readonly type="[Encounter Service] Note Addendum Added";
        constructor(public payload: {encounterId: number, noteId: number, addendum: NoteAddendum}){}
    }

    export class AppointmentAdded
    {
        static readonly type="[Encounter Service] Appointment Added";
        constructor(public payload: {encounterId: number, appointment: Appointment}){}
    }

    export class AppointmentCancelled
    {
        static readonly type="[Encounter Service] Appointment Cancelled";
        constructor(public payload: {encounterId: number, appointment: Appointment}){}
    }

    export class AppointmentUpdated
    {
        static readonly type="[Encounter Service] Appointment Updated";
        constructor(public payload: {encounterId: number, appointment: Appointment}){}
    }

    export class MedicalBillSet
    {
        static readonly type="[Encounter Service] Medical Bill Set";
        constructor(public payload:{encounterId: number, medicalBill:MedicalBill}){}
    }
    export class MedicalBillAdded
    {
        static readonly type="[Encounter Service] Medical Bill Added";
        constructor(public payload:{encounterId: number, medicalBill:MedicalBill}){}
    }

    export class MedicalBillUpdated
    {
        static readonly type="[Encounter Service] Medical Bill Updated";
        constructor(public payload:{encounterId: number, medicalBill:MedicalBill}){}
    }

    export class MedicalBillImageAdded
    {
        static readonly type="[Medical Bill Service] Medical Bill Image Set";
        constructor(public payload:{encounterId: number, billId:number}){}
    }

    export class MedicalBillImageRemoved
    {
        static readonly type="[Medical Bill Service] Medical Bill Image Removed";
        constructor(public payload:{encounterId: number, billId:number}){}
    }

    export class MedicalBillRemoved
    {
        static readonly type="[Encounter Service] Medical Bill Removed";
        constructor(public payload:{encounterId: number, medicalBill:MedicalBill}){}
    }
    export class AdditionalMedicalBillRemoved
    {
        static readonly type="[Encounter Service] Additional Bill Removed";
        constructor(public payload:{encounterId: number, medicalBill:MedicalBill}){}
    }

    export class FinanceServiceEncounterInvoiceCreated
    {
        static readonly type="[Finance Service] Invoice Created";
        constructor(public payload:{invoice: Invoice, encounterId:number}){}
    }
    export class FinanceServiceEncounterBillCreated
    {
        static readonly type="[Finance Service] Bill Created";
        constructor(public payload:{bill: Bill, encounterId: number}){}
    }

    export class EncounterServiceEncounterFinancialsPosted
    {
        static readonly type="[Encounter Service] Financials Posted";
        constructor(public payload:{financials:EncounterFinancials}){};
    }

    export class EncounterServiceEncounterFinancialsUnPosted
    {
        static readonly type="[Encounter Service] Financials UnPosted";
        constructor(public payload:{financials:EncounterFinancials}){};
    }

    export class EncounterServiceAttachmentAdded
    {
        static readonly type="[Encounter Service] Attachment Added";
        constructor(public payload:{encounterId: number, file: HarloweSupport.File}){};
    }

    export class EncounterServiceAttachmentsAdded
    {
        static readonly type="[Encounter Service] Attachments Added";
        constructor(public payload:{encounterId: number, files: HarloweSupport.File[]}){};
    }
    
    export class EncounterServiceAttachmentDeleted
    {
        static readonly type="[Encounter Service] Attachment Deleted";
        constructor(public payload:{encounterId: number, file: HarloweSupport.File}){};
    }

    export class EncounterServiceEncounterEmailSent
    {
        static readonly type="[Encounter Service] Email Sent";
        constructor(public payload:{encounterId: number, email: SentEmail}){};
    }
    export class EncounterServiceEncounterEmailReceived
    {
        static readonly type="[Encounter Service] Email Received";
        constructor(public payload:{encounterId: number, email: ReceivedEmail}){};
    }

}